import { callMsGraph } from '../graph';

/**
 * Get user email from Microsoft Graph API
 * @param {string} accessToken - Microsoft Graph access token
 * @returns {Promise<string|null>} User email or null if not found
 */
export async function getUserEmailFromGraph(accessToken) {
  try {
    const userProfile = await callMsGraph(accessToken);
    return userProfile?.mail || userProfile?.userPrincipalName || null;
  } catch (error) {
    console.error('Failed to get user email from Graph:', error);
    return null;
  }
}

/**
 * Get user email from various sources
 * @returns {Promise<string|null>} User email or null if not found
 */
export async function getUserEmail() {
  // Try sessionStorage first
  let email = sessionStorage.getItem('email');
  if (email) return email;
  
  // Try from stored user info
  const userInfo = localStorage.getItem('obj_user_info');
  if (userInfo) {
    try {
      const parsed = JSON.parse(userInfo);
      if (parsed?.email) return parsed.email;
    } catch (e) {
      console.warn('Failed to parse stored user info:', e);
    }
  }
  
  // Try from Graph API if we have access token
  const graphToken = sessionStorage.getItem('GraphAccessToken');
  if (graphToken) {
    try {
      const graphTokenParsed = JSON.parse(graphToken);
      email = await getUserEmailFromGraph(graphTokenParsed.value);
      if (email) {
        // Cache it for future use
        sessionStorage.setItem('email', email);
        return email;
      }
    } catch (e) {
      console.warn('Failed to get email from Graph:', e);
    }
  }
  
  return null;
}

export default getUserEmail;
